import { flow, applySnapshot } from 'mobx-state-tree';
import api from '~/api';
import { toMapById } from '~/mst/utils';
import type { ICalibrationsModel } from './model';

export default (self: ICalibrationsModel) => ({
  fetch: flow(function* fetch(params, options) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.calibrations.fetch, params, options);
      applySnapshot(self.models, toMapById(data, 'node_id'));
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),
  create: flow(function* create(payload) {
    self.startSyncing();
    try {
      const { data } = yield api.calibrations.create(payload);
      self.finishSyncing();
      return data;
    } catch (error: any) {
      // Capture the 400 body before failSyncing rethrows a stringified error and loses it.
      // `validation` is absent when the request was rejected before a snapshot (bad config).
      const body = error?.response?.data;
      try {
        self.failSyncing(error);
      } catch {
        /* failSyncing rethrows; we surface a structured failure instead */
      }
      const failure: any = new Error('calibration_failed');
      failure.detail = body?.errors?.detail;
      failure.validation = body?.validation;
      throw failure;
    }
  }),
  reset: flow(function* reset(serials) {
    self.startSyncing();
    try {
      const { data } = yield api.calibrations.reset({ serials });
      self.finishSyncing();
      return data;
    } catch (error) {
      self.failSyncing(error);
    }
    return null;
  })
});
